import { defineStore } from "pinia";
import db from "@/db";
import crudGenerator from "@/api/utils/offlineSync";

const { innerCreate, innerUpdate, innerFetch } = crudGenerator(
  db.models.AdminInformation
);

export const useAdminInformationsStore = defineStore("adminInformations", {
  state: () => ({
    currentAdminInformations: null,
  }),
  actions: {
    async createAdminInformation(form) {
      const adminInformation = await innerCreate(
        form,
        !window.navigator.onLine
      );
      this.currentAdminInformations = adminInformation;
      return adminInformation;
    },

    async updateAdminInformation(form) {
      const adminInformation = await innerUpdate(
        form,
        !window.navigator.onLine
      );
      this.currentAdminInformations = adminInformation;
      return adminInformation;
    },

    async fetchAdminInformation() {
      await innerFetch({}, !window.navigator.onLine);
      this.currentAdminInformations = await db.adminInformations
        .toCollection()
        .first();
    },
  },
});
